/** Shared platform margin % — used by Overview and Overview (Beta). */
export const platformMarginStorageKey = (platform: string) => `platform_${platform}_margin`;

export function getPlatformMargin(platform: string): number {
  const saved = localStorage.getItem(platformMarginStorageKey(platform));
  return saved ? Number(saved) : 0;
}

export function setPlatformMargin(platform: string, margin: number): void {
  localStorage.setItem(platformMarginStorageKey(platform), margin.toString());
}
